/* eslint-disable react/jsx-indent */
/* eslint-disable */
import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import PropTypes from 'prop-types';
import { getJson } from 'session';
import moment from 'moment';
import { Acl } from 'modules/common/components/Acl'
import ConfirmLabTest from 'modules/common/components/ConfirmLabTest';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import ProfileInformation from './ProfileInformation'

// import VerifyReceipt from '../components/VerifyReceipt';
import * as action from '../action';
import * as c from '../constant';
// import UpdateAppointmentModal from '../components/UpdateAppointmentModal';

function IncidentContent({
  match,
  clearIncident,
  isLoading,
  permissions,
  incidentInfo,
  showIncidentList,
}) {
  const selectIncident = match.params.id;

  const updateData = () => {
    showIncidentList(selectIncident);
  };

  useEffect(() => {
    if (!_.isEmpty(selectIncident)) {
      updateData();
    }
    return () => {
      clearIncident();
    };
  }, []);

  useEffect(() => {
    if (!_.isEmpty(selectIncident)) {
      updateData();
    }
  }, [selectIncident]);

  return (
    <>
      <div className="card-section-content container-fluid">
        {isLoading && (
          <div className="loading">
            <div className="spinner text-center">
              <span className="fas fa-1x fa-spin fa-spinner" />
            </div>
          </div>
        )}
        <div className="pt-3 px-3" style={{ fontSize: '24px' }}>
          <strong>{_.get(incidentInfo, 'attributes.reporter_name')}</strong>
        </div>
        <div className="right-section-content">
          {/* GRAY HIGHLIGHT */}
          <div className="row highlight d-flex align-items-center mx-3 py-3">
            <div className="col-12 px-0 mt-0 mb-1">
              {/* BORDER */}
              <div className="card border-primary">
                <div className="container-fluid py-1">
                  <Tabs>
                    <TabList>
                      <Tab>Profile</Tab>
                    </TabList>
                    <TabPanel>
                      <ProfileInformation
                        incidentInfo={incidentInfo}
                      />
                    </TabPanel>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

IncidentContent.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  clearIncident: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  
  permissions: PropTypes.instanceOf(Object).isRequired,
  
  incidentInfo: PropTypes.instanceOf(Object).isRequired,
  showIncidentList: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  permissions: getJson('permissions'),
  
  incidentInfo: _.get(api, `${c.SHOW_INCIDENT}.item`) || {},
  showIncidentList: _.get(api, `${c.SHOW_INCIDENT}`) || {},

  isLoading: api.loading.indexOf(c.SHOW_INCIDENT) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, action)]);

export default enhance(IncidentContent);
